/**
 * D-02 «Горячие клавиши desktop».
 *
 * §4.6 п. 2: перечень берётся из таблицы раздела и не сокращается;
 * п. 4: на mobile и в сенсорных раскладках подсказка не показывается.
 */
import { SHORTCUTS } from '../../model/hotkeys'
import { Sheet } from '@shared/ui'

import styles from './shortcuts.module.css'

export function ShortcutsSheet({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}): React.ReactElement {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title="Горячие клавиши"
      description="Каждое действие доступно и мышью — клавиша только ускоряет."
    >
      <dl className={styles['list']}>
        {SHORTCUTS.map((shortcut) => (
          <div key={shortcut.keys + shortcut.action} className={styles['row']}>
            <dt className={styles['keys']}>
              {shortcut.keys.split(' + ').map((key) => (
                <kbd key={key} className={styles['key']}>
                  {key}
                </kbd>
              ))}
            </dt>
            <dd className={styles['meaning']}>
              <span className={styles['action']}>{shortcut.action}</span>
              <span className={styles['context']}>{shortcut.context}</span>
            </dd>
          </div>
        ))}
      </dl>
    </Sheet>
  )
}
